/**
 * Previous / Next OPSI navigation: pages within a topic, then into adjacent topics.
 */

export const OpsiTopicNav = ({
  onPrevious,
  onNext,
  isFirstItem,
  isLastItem,
  className = "opsi-topic-nav",
}) => (
  <nav
    className={`${className} flex w-full items-center justify-between gap-4`}
    aria-label="OPSI page navigation"
  >
    <button
      type="button"
      onClick={onPrevious}
      disabled={isFirstItem}
      className={`rounded-full bg-[#993189] px-8 py-2.5 text-[1rem] font-medium text-white transition ${
        isFirstItem
          ? "cursor-default opacity-30"
          : "opacity-100 hover:bg-[#993189]"
      }`}
      aria-disabled={isFirstItem}
    >
      Previous
    </button>

    <button
      type="button"
      onClick={onNext}
      disabled={isLastItem}
      className={`rounded-full bg-[#993189] px-8 py-2.5 text-[1rem] font-medium text-white transition ${
        isLastItem
          ? "cursor-default opacity-30"
          : "opacity-100 hover:bg-[#993189]"
      }`}
      aria-disabled={isLastItem}
    >
      Next
    </button>
  </nav>
);
